(function () {
    'use strict';

    angular
        .module('services.language', [])
        .constant('AVAILABLE_LANGUAGES', [
            { id: 'en', label: 'English' },
            { id: 'fr', label: 'Fran\u00e7ais' }
        ])
        .factory('languageService', service);

    service.$inject = ['$window', '$rootScope', 'AVAILABLE_LANGUAGES'];

    function service($window, $rootScope, AVAILABLE_LANGUAGES) {
        var STORAGE_KEY = 'preferredLanguage';
        var currentLanguageId = null;

        return {
            getAvailableLanguages: getAvailableLanguages,
            getCurrentLanguage: getCurrentLanguage,
            setLanguage: setLanguage,
            initializeLanguage: initializeLanguage,
            translateProperty: translateProperty
        };

        function getAvailableLanguages() {
            return AVAILABLE_LANGUAGES;
        }

        function getCurrentLanguage() {
            var currentLang = AVAILABLE_LANGUAGES.filter(function (lang) {
                return lang.id === currentLanguageId;
            })[0];
            return currentLang || AVAILABLE_LANGUAGES[0];
        }

        function setLanguage(langId) {
            currentLanguageId = langId;
            try {
                $window.localStorage.setItem(STORAGE_KEY, langId);
            } catch (e) {
                console.warn('[languageService] Could not save language preference:', e);
            }
            $window.location.reload();
        }

        function initializeLanguage() {
            var storedLang = null;
            try {
                storedLang = $window.localStorage.getItem(STORAGE_KEY);
            } catch (e) {
                console.warn('[languageService] Could not access localStorage:', e);
            }

            var browserLang = ($window.navigator.language || $window.navigator.userLanguage || 'en').split('-')[0];
            var isBrowserLangSupported = AVAILABLE_LANGUAGES.some(function (lang) {
                return lang.id === browserLang;
            });

            var initialLang = storedLang || (isBrowserLangSupported ? browserLang : 'en');
            currentLanguageId = initialLang;

            // Set on $rootScope for template access (uppercase for TitleEN/TitleFR pattern)
            $rootScope.currentLang = initialLang.toUpperCase();

            return getCurrentLanguage();
        }

        /**
         * Get the property value of an object based on a given language, with a default property if
         * no translation available.
         * @param object {object}
         * @param translationParam {object}
         * @param translationParam.default {string}
         * @param translationParam.fr {string}
         * @param languageCode {'EN'|'FR'}
         */
        function translateProperty(object, translationParam, languageCode) {
            var code = languageCode.toLocaleLowerCase();
            var propertyToReturn = object[translationParam[code]];

            if (translationParam.hasOwnProperty(code)
                && object.hasOwnProperty(translationParam[code])
                && !_.isNil(propertyToReturn)) {
                return propertyToReturn;
            }

            return object[translationParam['default']];
        }
    }
})();
